export default __webpack_public_path__ + "static/media/img7.bd9c5d08.jpg";